<template>
  <router-view v-slot="{ Component, route: currentRoute }">
    <transition name="fade-in" appear>
      <component :is="Component" :key="currentRoute.matched[0]?.path || currentRoute.path" />
    </transition>
  </router-view>

  <the-language-switcher v-if="!!languages && languages.length > 0" />

  <the-general-components />
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted } from 'vue';
import TheGeneralComponents from '@/components/vendor/generalModals/TheGeneralComponents.vue';
import { useAppStore } from '@/stores/app';
import useConcepts from '@/helpers/Concepts';
import TheLanguageSwitcher from '@/components/layout/parts/TheLanguageSwitcher.vue';
import { getAppLanguages } from '@/helpers/ConceptHelper';
import { startIdleLogout } from '@/helpers/idleLogout';

export default defineComponent({
  name: 'App',
  components: {
    TheLanguageSwitcher,
    TheGeneralComponents,
  },
  setup() {
    const appStore = useAppStore();
    appStore.init();

    let stopIdleLogout: (() => void) | undefined;

    onMounted(() => {
      stopIdleLogout = startIdleLogout();
    });

    onUnmounted(() => {
      stopIdleLogout?.();
    });

    return {
      ...useConcepts(),
    };
  },
  computed: {
    languages(): any[] {
      return getAppLanguages();
    },
  },
  created() {
    document.title = import.meta.env.VITE_APP_TITLE;
  },
});
</script>

<style lang="scss" scoped>
.logo {
  height: 6em;
  padding: 1.5em;
  will-change: filter;
}

.logo:hover {
  filter: drop-shadow(0 0 2em #646cffaa);
}

.logo.vue:hover {
  filter: drop-shadow(0 0 2em #42b883aa);
}
</style>
